/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-13 19:28:40
 * @Description: 后台路由
 */
"use strict";
angular.module("userManagementRouterModule", []).
config(["$stateProvider", function ($stateProvider) {
  $stateProvider.state("backstage.usermanagement", {
    url: "/usermanagement",
    views: {
      "": {
        template: '<div class="userManagement" ui-veiw="main"></div>',
      }
    }
  }).state("backstage.organization.userdisplay", {
    url: "/userdisplay",
    views: {
      "main@backstage": {
        templateUrl: './main/backstage/userManagement/userDisplay/userDisplay_tpl.html',
        controller: 'userDisplayCtrl'
      }
    }
  }).state("backstage.usermanagement.registrationaudit", {
    url: "/registrationaudit",
    views: {
      "main@backstage": {
        templateUrl: './main/backstage/userManagement/registrationAudit/registrationAudit_tpl.html',
        controller: 'registrationAuditCtrl'
      }
    }
  }).state("backstage.usermanagement.userinformation", {
    url: "/userinformation",
    views: {
      "main@backstage": {
        templateUrl: './main/backstage/userManagement/userInformation/userInformation_tpl.html',
        controller: 'userInformationCtrl'
      }
    }
  }).state("backstage.usermanagement.pgcuserinformation", {
    url: "/pgcuserinformation",
    views: {
      "main@backstage": {
        templateUrl: './main/backstage/userManagement/pgcUserInformation/pgcUserInformation_tpl.html',
        controller: 'pgcUserInformationCtrl'
      }
    }
  }).state("backstage.organization.rolemanagement", {
    url: "/rolemanagement",
    views: {
      "main@backstage": {
        templateUrl: './main/backstage/userManagement/roleManagement/roleManagement_tpl.html',
        controller: 'roleManagementCtrl'
      }
    }
  }).state("backstage.organization.rolemanagement.usermanagementforrole", {
    url: "/usermanagementforrole?roleId&roleName",
    views: {
      "main@backstage": {
        templateUrl: './main/backstage/userManagement/roleManagement/userManagementForRole/userManagementForRole_tpl.html',
        controller: 'userManagementForRoleCtrl'
      }
    }
  });
}]);
